export default "/_next/static/images/img3-6d85c1f49c4580081f7159a4799d37aa.png";